import { default as NewsGallery } from './NewsGallery'
export { default as NewsGalleryReducer } from './model/slice'
export default NewsGallery
